export default IconArrowsDiagonalMinimize => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrows-diagonal-minimize" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 10h4v-4" />
  <path d="M4 4l6 6" />
  <path d="M18 14h-4v4" />
  <path d="M14 14l6 6" />
</svg>`;